import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';

import { BreadcrumbGroup, Checkbox, FormField, Header, Select, SpaceBetween } from '@cloudscape-design/components';
import '@fullcalendar/react/skeleton.css';
import '@fullcalendar/react/themes/classic/palette.css';
import '@fullcalendar/react/themes/classic/theme.css';

import { mdiTagHidden } from '@mdi/js';
import Icon from '@mdi/react';
import { endOfDay, format, isAfter, isBefore, isEqual, parse, parseISO, startOfDay } from 'date-fns';
import '../../../../../../src/components/css/FullCalendar.css';
import BookingGrid from '../../../../../components/BookingGrid';
import DPModal from '../../../../../components/DPModal';
import Confirm from '../../../../../components/extras/Confirm';
import ConfirmDelete from '../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemEquipment } from '../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { CustomAppLayout } from '../../../layout';
// TEMPORARILY REMOVE MONARCH


export const MembersBookingsPlanningPage: React.FC = () => {
    const { menu, parameters, idUser, data } = useGlobalState();
    const [onlyBookings, setOnlyBookings] = useState(true);
    const [showPrivates, setShowPrivates] = useState(false);
    const [bookings, setBookings] = useState<any[]>([]);
    const [blockings, setBlockings] = useState<any[]>([]);
    const [info, setInfo] = useState<any>();
    const [bookingDelete, setBookingDelete] = useState<any>();

    const handleResourceClick = (resourceProps: ItemEquipment) => {
        //console.log("Resource clicked:", resourceProps);
    };

    const handleDateClick = (date: string, resourceProps: ItemEquipment) => {

        if (resourceProps.jsonOwners.length > 0 && !resourceProps.jsonOwners.includes(idUser)) {
            console.log("Reason: User is not an owner");
            return;
        }
        const targetDate = date !== "" ? parse(date, "dd-MM-yyyy HH:mm", new Date()) : parse(parameters.date + " 09:00", "dd-MM-yyyy HH:mm", new Date());
        if (isBefore(targetDate, startOfDay(new Date()))) {
            console.log("Reason: Date is before today");
            return;
        }
        const parseCustomDate = (str: any) => {
            if (!str || typeof str !== 'string') return null;
            const trimmed = str.trim();

            // 1. Check if ISO string (contains 'T')
            if (trimmed.includes('T')) {
                const parsedISO = parseISO(trimmed);
                return isNaN(parsedISO.getTime()) ? null : parsedISO;
            }

            // 2. Check string formats based on character patterns
            let formatString = 'dd-MM-yyyy';

            if (trimmed.includes(' ')) {
                const timePart = trimmed.split(' ')[1];
                const colons = (timePart.match(/:/g) || []).length;

                if (colons === 2) {
                    formatString = 'dd-MM-yyyy HH:mm:ss';
                } else if (colons === 1) {
                    formatString = 'dd-MM-yyyy HH:mm';
                }
            }

            const parsed = parse(trimmed, formatString, new Date());
            return isNaN(parsed.getTime()) ? null : parsed;
        };

        const isDateInRange = (target: any, startStr: any, endStr: any) => {
            const rawStart = parseCustomDate(startStr);
            const rawEnd = parseCustomDate(endStr);

            const startHasTime = Boolean(startStr && (startStr.includes('T') || startStr.includes(' ')));
            const endHasTime = Boolean(endStr && (endStr.includes('T') || endStr.includes(' ')));

            const startDate = rawStart && !startHasTime ? startOfDay(rawStart) : rawStart;
            const endDate = rawEnd && !endHasTime ? endOfDay(rawEnd) : rawEnd;

            // Inclusive start: A blocking starting at 13:00 blocks 13:00 (target >= start)
            const isAfterOrEqual = (t: any, s: any) => isAfter(t, s) || isEqual(t, s);

            // Exclusive end when time is provided: A blocking ending at 13:00 DOES NOT block 13:00 (target < end)
            const isStrictlyBefore = (t: any, e: any) => isBefore(t, e);

            if (startDate && endDate) {
                // If end has time, use strict < ; if date-only (23:59:59), use <=
                const endValid = endHasTime ? isStrictlyBefore(target, endDate) : (isBefore(target, endDate) || isEqual(target, endDate));
                return isAfterOrEqual(target, startDate) && endValid;
            } else if (startDate) {
                return isAfterOrEqual(target, startDate);
            } else if (endDate) {
                return endHasTime ? isStrictlyBefore(target, endDate) : (isBefore(target, endDate) || isEqual(target, endDate));
            }
            return false;
        };
        if (resourceProps.isOutOfFlight === 1) {
            const { outOfFlightStart, outOfFlightEnd } = resourceProps;
            if (outOfFlightStart === "" && outOfFlightEnd === "") {
                console.log("Reason: Out of flight complete");
                return;
            }
            if (outOfFlightStart || outOfFlightEnd) {
                if (isDateInRange(targetDate, outOfFlightStart, outOfFlightEnd)) {
                    console.log("Reason: Out of flight single");
                    return;
                }
            }
        }

        // 3. Check Resource Blockings

        if (Array.isArray(blockings) && blockings.length > 0) {
            const hasActiveBlocking = blockings
                .filter((e: any) => e.idEquipment === resourceProps.idEquipment)
                .some((blocking) => {
                    const { startDateTime, endDateTime } = blocking;
                    if (!startDateTime && !endDateTime) return false;
                    return isDateInRange(targetDate, startDateTime, endDateTime);
                });
            if (hasActiveBlocking) {
                console.log("Reason: Active blocking");
                return;
            }
        }

        setInfo({
            date: format(targetDate, "dd-MM-yyyy"),
            startTime: format(targetDate, "H"),
            idEquipment: resourceProps.idEquipment,
            registration: resourceProps.registration,
            idGroupType: resourceProps.idGroupType,
        });
        //http://[::1]:9616/#members/bookings/book?date=10-10-2026&idGroupType=1044
    };


    const handleRefresh = async () => {
        if (parameters && parameters.date && parameters.date !== "") {
            try {
                setBookings([]);
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/bookings/list',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify({
                        dateBetween: parameters.date,
                        blockings: true,
                        orderBy: "ordenGroupType",
                        order: "ASC",
                        orderBy2: "dateEnd",
                        order2: "ASC"
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                if (data && data.bookings) {
                    setBookings(data.bookings);
                }
                if (data && data.blockings) {
                    setBlockings(data.blockings);
                }

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        handleRefresh();
    }, [parameters.date]);

    const handleDeleteBooking = async (idBooking: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/bookings/delete',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idBooking: idBooking,
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data) {
                addNotificationStatus(data, setData);
                setBookingDelete(undefined);
                if (data.code === 0) {
                    handleRefresh()
                }
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    return (
        <>
            <CustomAppLayout
                toolsHide={true}
                breadcrumbs={
                    <BreadcrumbGroup
                        items={buildBreadcrumbItems(menu)}
                        expandAriaLabel="Show path"
                        ariaLabel="Breadcrumbs"
                    />
                }
                content={
                    <SpaceBetween size="s">
                        <Header variant="h1" actions={<Favorites />}>Grilla de Reservas</Header>
                        <SpaceBetween size="s" direction="vertical">
                            <SpaceBetween size="s" direction="horizontal">
                                <FormField label="Fecha">

                                    <DPModal width={105} today date={parameters.date} clear={false} tomorrow onConfirm={(date) => {
                                        if (date !== "") {
                                            const updatedParameters = {
                                                ...parameters, // clone existing keys
                                                date: (date) // add or update
                                            };
                                            setParameters(updatedParameters);
                                        }
                                    }} />
                                </FormField>
                                <FormField label="Tipo">
                                    <div style={{ width: 200 }}>
                                        <Select
                                            expandToViewport
                                            options={[
                                                { label: "Todos", value: "0" },
                                                ...(data?.groupTypes?.filter((g: any) => g.showOnBooking === 1) // filter out any falsy values before mapping
                                                    .map((g: any) => ({
                                                        label: g.groupType,
                                                        value: String(g.idGroupType)
                                                    })) || [])
                                            ]}
                                            selectedOption={
                                                Number(parameters.idGroupType) === 0
                                                    ? { label: "Todos", value: "0" }
                                                    : (() => {
                                                        const selected = data?.groupTypes?.find(
                                                            (g: any) => Number(g.idGroupType) === Number(parameters.idGroupType)
                                                        );
                                                        return selected
                                                            ? { label: selected.groupType, value: String(selected.idGroupType) }
                                                            : { label: "Todos", value: "0" };
                                                    })()
                                            }
                                            onChange={(value) => {
                                                const selectedVal = Number(value.detail.selectedOption.value);
                                                setParameters({ ...parameters, idGroupType: selectedVal });
                                            }}
                                        />
                                    </div>
                                </FormField>
                            </SpaceBetween>

                            <SpaceBetween size="s" direction="horizontal">

                                <Checkbox checked={onlyBookings} onChange={({ detail }) => setOnlyBookings(!onlyBookings)}>Solo reservas</Checkbox>
                                <Checkbox checked={showPrivates} onChange={({ detail }) => setShowPrivates(!showPrivates)}>
                                    Ver privados<Icon path={mdiTagHidden} size={0.8} />
                                </Checkbox>


                                {/*<Button onClick={handleButtonClick}>Refresh Equipments</Button>*/}
                            </SpaceBetween>
                        </SpaceBetween>
                        <BookingGrid bookings={bookings} blockings={blockings} date={parameters.date} showPrivates={showPrivates} showOnlyBookings={onlyBookings}
                            onResourceClick={handleResourceClick}
                            onDateClick={handleDateClick}
                            onBookingDelete={(booking) => setBookingDelete(booking)}
                        />
                        {!!bookingDelete && (

                            <ConfirmDelete show={bookingDelete} confirmWord={'eliminar'} header='Se requiere confirmación' action={'Eliminar'} warning={`Se requiere su confirmación para proceder con la eliminación de la reserva ${bookingDelete?.idBooking || ""}`} onDismiss={() => setBookingDelete(false)}
                                onConfirm={() => {
                                    handleDeleteBooking(bookingDelete.idBooking);
                                }}
                            />
                        )}
                        {!!info && (
                            <Confirm
                                type="info"
                                onDismiss={() => setInfo(null)} show={!!info} action={'Reservar'}
                                warning={`Ir a reservar el ${info?.registration} el ${info?.date} desde las ${info?.startTime}:00`}
                                onConfirm={() => {
                                    window.location.hash = `#members/bookings/book?date=${info?.date}&idGroupType=${info?.idGroupType}&idEquipment=${info?.idEquipment}&startTime=${info?.startTime ?? "9"}&callBack=#members/bookings/planning`;
                                }}
                            />
                        )}
                    </SpaceBetween>
                }
            />
        </>
    )
};
